import React, {FC} from 'react';
import styled from 'styled-components';

import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {CompanyModel, defaultCompanyName} from '../../../models/api/companyModel';
import {Avatar, AvatarProps} from './avatar';
import {AvatarBackground} from './avatarBackground';
import {AvatarInitials} from './avatarInitials';

/*
 * Props.
 */

interface CompanyAvatarProps extends AvatarProps {
  /** The company to display. */
  company: CompanyModel;
}

/*
 * Style.
 */

const StyledAvatarBackground = styled(AvatarBackground)`
  border-radius: 4px;
`;

/*
 * Component.
 */

/** Display the avatar of the specified company. */
export const CompanyAvatar: FC<CompanyAvatarProps> = (props) => {
  const {company, size} = props;
  const {name, color} = company;
  // If company name is [Unknown Company Name], don't render an initial.
  const initial = name === defaultCompanyName ? '' : name[0] || '';
  const theme = useUserTheme();

  return (
    <Avatar {...props}>
      <StyledAvatarBackground color={theme.avatar.findTeamBackground(theme, color)} />
      <AvatarInitials
        size={size}
        textColor={theme.avatar.findTeamColor(theme, color)}
        value={initial}
        isBold
      />
    </Avatar>
  );
};
